<!-- 登录弹窗 -->
<!-- 弹窗组件在public里的loginDia上 -->
<template>
  <div class="loginBox dip fdcolmun">
    <router-link to="/" class="logoBox">
      <img
        class="logoImg"
        :src="require('@/assets/hometop/logo-rakumart-europe.svg')"
        alt=""
      />
    </router-link>

    <div class="loginTitleFont">
      <h2>{{ $fanyi("登录Rakumart") }}</h2>
      <h3>{{ $fanyi("输入您的登录凭证") }}</h3>
    </div>

    <div>
      <el-form
        :model="$parent.loginData"
        :rules="$parent.loginRules"
        ref="loginForm"
        class="demo-ruleForm"
      >
        <el-form-item prop="login_name">
          <div class="fromName">
            <!-- 用户名 -->
            <div class="placeholder">E-mail</div>
          </div>
          <el-input
            v-model="$parent.loginData.login_name"
            :placeholder="$fanyi('写你的电子邮件')"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <div class="fromName">
            <!-- 密码 -->
            <div class="placeholder">{{ $fanyi("密码") }}</div>
          </div>
          <el-input
            v-model="$parent.loginData.password"
            type="password"
            :placeholder="$fanyi('输入您的密码')"
            v-if="!showPassword"
          ></el-input>
          <el-input
            v-model="$parent.loginData.password"
            :placeholder="$fanyi('输入您的密码')"
            v-else
          ></el-input>
          <div
            class="forgotPasswordBox"
            @click="
              $store.commit('getshowLoginDialog', false);
              $fun.routerToPage('/Reimposta-password');
            "
          >
            {{ $fanyi("忘记密码？") }}
          </div>
          <div class="showPaddwordBox" @click="showPassword = !showPassword">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202409/66e509791a06a.svg"
              alt=""
            />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="rememberPassword">
      <el-switch v-model="$parent.Save_the_password" active-color="#009246">
      </el-switch>
      <span>{{ $fanyi("保持登录状态") }}</span>
    </div>

    <button class="bgBlueBtn loginBtn" @click="$parent.login">
      {{ $fanyi("登录") }}
    </button>

    <!-- 第三方谷歌登录入口 -->
    <div class="third-party-login">
      <div class="googlelogin" @click="$parent.gugedenglu">
        <img
          class="g-icon"
          :src="require('@/assets/login/google.svg')"
          alt=""
        />
        {{ $fanyi("Google 注册/登录") }}
      </div>
      <!-- 谷歌官方按钮挂载点(隐藏) -->
      <div id="googleBtnProviderDialog"></div>
    </div>

    <div class="goRegisterBox">
      {{ $fanyi("没有账户？") }}
      <b
        @click="
          $store.commit('getshowLoginDialog', false);
          $store.commit('getshowRegisterDialog', true);
        "
        >{{ $fanyi("立即注册") }}</b
      >
    </div>

    <!-- 新用户默认密码提示 -->
    <InfoDialog ref="InfoDialogRef" />
  </div>
</template>
<script>
import InfoDialog from "@/components/public/InfoDialog.vue";
export default {
  data() {
    return {
      showPassword: false,
    };
  },
  components: {
    InfoDialog,
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.loginBox {
  width: 471px;
  padding: 32px 24px;
  border-radius: 16px;
  border: 1.5px solid var(--Gray-200, #eaecf0);
  background: #fff;

  /* Shadows/shadow-2xl */
  box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);
  .logoImg {
    width: 168px;
    height: 45.405px;
    margin-bottom: 24px;
  }

  .loginTitleFont {
    margin-bottom: 24px;
    text-align: center;
    h2 {
      color: #013b2d;
      margin-bottom: 8px;
      font-size: 18px;
      font-weight: 700;
      line-height: 28px; /* 155.556% */
    }
    h3 {
      color: var(--Gray-500, #667085);
      text-align: center;

      font-size: 16px;
      line-height: 24px; /* 150% */
    }
  }

  .demo-ruleForm {
    width: 423px;
    margin-bottom: 24px;
    /deep/.el-form-item__content {
      height: 65px;
    }
    /deep/.placeholder {
      color: var(--Gray-700, #344054);
      font-size: 14px;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      margin-bottom: 8px;
      position: relative;
    }
    /deep/.el-input__inner {
      padding: 0px 16px;
      gap: 8px;
      height: 40px;
      border-radius: 8px;
      border: 1px solid var(--Gray-200, #eaecf0);
      background: #fff;

      font-size: 16px;
      line-height: 24px; /* 150% */
      &::placeholder {
        color: var(--Gray-300, #d0d5dd);
      }
    }
    .forgotPasswordBox {
      color: var(--Rakumart-500, #009246);
      font-size: 12px;
      font-weight: 600;
      line-height: 18px; /* 150% */
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
    .showPaddwordBox {
      cursor: pointer;
      position: absolute;
      top: 34px;
      right: 16px;
    }
  }
  .rememberPassword {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    .el-switch {
      margin-right: 16px;
      /deep/.el-switch__input {
        display: none;
      }
    }
  }
  .loginBtn {
    width: 100%;
    padding: 12px 18px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px; /* 150% */
    margin-bottom: 24px;
  }
  .goRegisterBox {
    color: var(--Gray-700, #344054);
    font-size: 14px;
    line-height: 20px; /* 142.857% */
    b {
      color: var(--Rakumart-500, #009246);
      font-weight: 600;
      cursor: pointer;
    }
  }
  /* 第三方谷歌登录 */
  .third-party-login {
    width: 100%;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .googlelogin {
      width: 100%;
      height: 48px;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 12px;
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid var(--Gray-200, #eaecf0);
      font-size: 16px;
      color: #344054;
      cursor: pointer;
      .g-icon {
        display: block;
        width: 20px;
        height: 20px;
      }
      &:hover {
        border-color: #009246;
      }
    }
    #googleBtnProviderDialog {
      width: 100%;
      display: none;
      justify-content: center;
      /deep/ iframe {
        margin: 0 auto;
      }
    }
  }
}
</style>
